var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tooltip-container" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.showTooltip
        ? _c(
            "div",
            {
              staticClass: "tooltip-box hidden-xs-down",
              class: _vm.classBindings
            },
            [
              _c("div", { staticClass: "tooltip-pointer" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tooltip-body text-center" },
                [
                  _vm._t("tooltip-body", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary"
                      },
                      [_vm._v("hello")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "typography--body-3 typography--color-secondary"
                      },
                      [_vm._v("world")]
                    )
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-action" }, [
                _c("img", {
                  staticClass: "close-tooltip clickable",
                  attrs: { src: "/static/images/icon-close-tooltip.svg" },
                  on: { click: _vm.close }
                })
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70596efa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70596efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tooltip.vue
// module id = G5b0
// module chunks = 1